/**
 * Limited designation display helpers.
 * Keep in sync with `@bilt/formatting` (formatLimitedDesignation*).
 */

export function formatLimitedDesignationOrdinal(
  ordinal: number,
  editionSize: number
): string {
  const size = Math.max(1, Math.floor(editionSize) || 1);
  const n = Math.max(0, Math.floor(ordinal) || 0);
  const width = Math.max(2, String(size).length);
  return `${String(n).padStart(width, '0')} / ${size}`;
}

export function formatLimitedDesignationTitle(
  name: string,
  ordinal: number,
  editionSize: number
): string {
  const size = Math.max(1, Math.floor(editionSize) || 1);
  const n = Math.max(0, Math.floor(ordinal) || 0);
  const width = Math.max(2, String(size).length);
  const ord = String(n).padStart(width, '0');
  return `${(name || '').trim()} ${ord} of ${size}`.trim();
}

export function formatLimitedDesignationA11yLabel(
  name: string,
  ordinal: number,
  editionSize: number,
  issuerLabel = 'Bilt:Spec'
): string {
  const base = `${(name || 'Limited designation').trim()} ${Math.floor(ordinal)} of ${Math.floor(editionSize)}`;
  return issuerLabel ? `${base}, issued by ${issuerLabel}` : base;
}

export function formatLimitedDesignationIssuedDate(
  value: string | null | undefined
): string | null {
  if (!value) return null;
  const trimmed = value.trim();
  if (!trimmed) return null;
  const date = new Date(trimmed.includes('T') ? trimmed : trimmed.replace(' ', 'T'));
  if (Number.isNaN(date.getTime())) return null;
  return date.toLocaleDateString(undefined, {
    month: 'short',
    day: 'numeric',
    year: 'numeric',
  });
}
